/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';

import { environment } from '@env/environment';
import { Logger, I18nService, AuthenticationService, HttpCacheService } from '@app/core';
import { WebSocketsService } from '@app/core/websockets/websockets.service';
import { AccessService } from '@app/core/access/access.service';

const log = new Logger('Login');

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  version: string = environment.version;
  error: string;
  loginForm: FormGroup;
  isLoading = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private i18nService: I18nService,
    private authenticationService: AuthenticationService,
    private websockets: WebSocketsService,
    private httpCache: HttpCacheService,
    private accessService: AccessService
  ) {
    this.createForm();
  }

  ngOnInit() {
    if (this.websockets.isConnected()) {
      this.websockets.disconnect();
    }
  }

  login() {
    this.isLoading = true;
    this.authenticationService
      .login(this.loginForm.value)
      .pipe(
        finalize(() => {
          this.loginForm.markAsPristine();
          this.isLoading = false;
        })
      )
      .subscribe((credentials) => {
        log.debug(`Successfully logged in`);
        this.accessService.clearStorage();
        //this.websockets.connect();
        this.httpCache.cleanCache();
        this.route.queryParams.subscribe((params) =>
          this.router.navigate([params.redirect || '/'], { replaceUrl: true })
        );
      });
  }

  setLanguage(language: string) {
    this.i18nService.language = language;
  }

  get currentLanguage(): string {
    return this.i18nService.language;
  }

  get languages(): string[] {
    return this.i18nService.supportedLanguages;
  }

  private createForm() {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      remember: true,
    });
  }
}
